module.exports = __webpack_public_path__ + "img/badge_gray_cap-experience.08e72e2f.svg";